<template>
  <div class="container">
    <div class="selectconditons">
      <j-input
        ref="scode"
        v-model="inputGroup.sourceName"
        placeholder="来源"
        style="width: 15%; margin-right: 2%"
        @pressEnter=";(pagination.current = 1), getTableDate()"
      >
        <a-icon slot="prefix" type="mobile" />
        <a-tooltip slot="suffix" title="要查找的来源信息">
          <a-icon type="info-circle" style="color: rgba(0, 0, 0, 0.45)" />
        </a-tooltip>
      </j-input>
      <a-button type="primary" icon="search" @click=";(pagination.current = 1), getTableDate()">搜索</a-button>
      <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
      <a-button type="primary" icon="plus" style="margin-left: 1%" @click="openAddModal()">添加一组信息</a-button>
    </div>
    <div class="selectresulttable">
      <a-table :columns="columns" :data-source="data" :pagination="false" :loading="loading" bordered>
        <!-- :scroll="{x:true}" -->
        <span slot="action" slot-scope="text, record">
          <a-button
            type="link"
            @click="editSource(record)"
            v-if="record.sources != '全部'"
            size="small"
            style="margin-right: 3px"
            >修改</a-button
          >
          <a-button
            type="link"
            style="color: #ff4d4f"
            v-if="record.sources != '全部'"
            @click="deleteSource(record)"
            size="small"
            >删除</a-button
          >
          <a-button type="link" @click="showDrawer(record)">配置用户</a-button>
          <a-button type="link" @click="openMangeSourcesAccount(record)">配置账号</a-button>
        </span>
      </a-table>
      <a-drawer
        title="配置用户可见来源"
        placement="right"
        :closable="false"
        :visible="drawerVisible"
        @close="onClose"
        width="60%"
      >
        <mange-sources-user @closeSourcesDrawer="closeSourcesDrawer" :sourcesid="sourcesid"></mange-sources-user>
      </a-drawer>
      <mange-sources-account ref="mangeSourcesAccount" />
      <div class="pageBar">
        <a-pagination
          style="margin-top: 1%; float: right"
          size="small"
          :current="pagination.current"
          :total="pagination.total"
          :show-total="(total, range) => `${range[0]}-${range[1]} 共 ${total} 条`"
          show-size-changer
          show-quick-jumper
          :showSizeChanger="true"
          :pageSize="pagination.pageSize"
          :pageSizeOptions="pagination.pageSizeOptions"
          @change="onChange"
          @showSizeChange="showSizeChange"
        />
      </div>
    </div>
    <manageSourceModal ref="manageSourceModal" @ok=";(pagination.current = 1), getTableDate()"></manageSourceModal>
  </div>
</template>

<script>
import moment from 'moment'
import mangeSourcesUser from './components/mangeSourcesUser'
import mangeSourcesAccount from './components/mangeSourcesAccount.vue'
import { deleteAction, getAction } from '@/api/manage'
import JInput from '@/components/jeecg/JInput'
import manageSourceModal from './modules/manageSourceModal.vue'
//表格字段名称
const columns = [
  {
    title: '来源名称',
    dataIndex: 'sourceName',
    key: 'sourceName',
    width: 110,
  },
  {
    title: '签名',
    dataIndex: 'signatures',
    key: 'signatures',
    width: 110,
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    key: 'createTime',
    width: 100,
    align: 'center',
  },
  {
    title: '修改时间',
    dataIndex: 'updateTime',
    key: 'updateTime',
    width: 100,
    align: 'center',
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
    width: 170,
  },
]

export default {
  components: {
    mangeSourcesUser,
    mangeSourcesAccount,
    manageSourceModal,
    JInput,
  },
  data() {
    return {
      columns,
      data: [],
      //页码数据
      pagination: {
        current: 1,
        total: 0,
        pageSizeOptions: ['5', '10', '15', '20'],
        pageSize: 10,
      },
      //查询参数
      inputGroup: {
        sourceName: '',
      },
      loading: false,
      drawerVisible: false,
      sourcesid: '',
      url: {
        list: '/base/busCommonMessageSourceNew/list',
        busCommonMessageSourceNewDelete: '/base/busCommonMessageSourceNew/delete',
      },
    }
  },
  mounted() {
    this.getTableDate()
  },
  methods: {
    /***
     * 重置
     */
    searchReset() {
      this.inputGroup = {}
      this.pagination.current = 1
      this.getTableDate()
    },
    closeSourcesDrawer(data) {
      this.drawerVisible = data
    },
    showDrawer(records) {
      this.sourcesid = records.id
      this.drawerVisible = true
    },
    onClose() {
      this.drawerVisible = false
    },
    openAddModal() {
      this.$refs.manageSourceModal.title = '添加短信来源'
      this.$refs.manageSourceModal.edit({ userName: this.$ls.get('Login_Userinfo').realname })
    },
    editSource(source) {
      //先赋值
      let obj = Object.assign({}, source, { userName: this.$ls.get('Login_Userinfo').realname })
      this.$refs.manageSourceModal.title = '修改短信来源'
      this.$refs.manageSourceModal.edit(obj)
    },
    //删除账号信息二步确认
    deleteSource(source) {
      this.$antdConfirm({
        title: '是否删除名字为：' + source.sources + '的来源?',
        content: (h) => (
          <div style="color:red;">
            <a-icon type="info-circle" style="margin-right:10px" />
            删除操作不可恢复的哦
          </div>
        ),
        okText: '是',
        okType: 'danger',
        cancelText: '点错啦',
        onOk: () => {
          this.doDelete(source.id)
        },
        onCancel: () => {
          this.$message.success('感谢您的仁慈！')
        },
      })
    },
    //删除信息账号
    doDelete(id) {
      let delDate = {
        id: id,
      }
      deleteAction(this.url.busCommonMessageSourceNewDelete, delDate).then((res) => {
        if (res.success) {
          this.$message.success(res.message)
          this.getTableDate()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //页面换页重新获取表格数据
    onChange(page, pageSize) {
      this.pagination.current = page
      this.pagination.pageSize = pageSize
      this.getTableDate()
    },
    //页面容量修改时重新获取表格数据
    showSizeChange(current, size) {
      this.pagination.current = current
      this.pagination.pageSize = size
      this.getTableDate()
    },
    //获取表格数据
    getTableDate() {
      this.loading = true
      let requestDate = {
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
        sourceName: this.inputGroup.sourceName,
      }
      getAction(this.url.list, requestDate).then((res) => {
        if (res.success) {
          this.data = res.result.records
          this.pagination.current = res.result.current
          this.pagination.total = res.result.total
        } else {
          this.$message.error(res.message)
        }
        this.loading = false
      })
    },
    openMangeSourcesAccount(record) {
      this.$refs.mangeSourcesAccount.open(record)
    },
  },
}
</script>

<style scoped>
.container {
  background-color: #ffffff;
  height: 100%;
  width: 100%;
}
.selectconditons {
  padding-top: 1%;
  padding-left: 1%;
  background-color: #ffffff;
}
.selectresulttable {
  padding: 0.5%;
  background-color: #ffffff;
}
.pageBar {
  width: 100%;
  height: 3rem;
  background-color: #ffffff;
}
.nullTips {
  color: red;
  font-size: 12px;
  line-height: 22px;
  text-align: center;
  margin: auto;
}
.width-100-per {
  width: 100%;
}
.margin-top-10 {
  margin-top: 20px;
}
</style>
